//
// Copyright 2021 DXOS.org
//
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_dxos_client_invitation } from "../client/invitation_pb.js";
import { file_dxos_echo_timeframe } from "../echo/timeframe_pb.js";
import { file_dxos_halo_credentials } from "./credentials_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
/**
 * Describes the file dxos/halo/invitations.proto.
 */
export const file_dxos_halo_invitations = /*@__PURE__*/ fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_dxos_client_invitation, file_dxos_echo_timeframe, file_dxos_halo_credentials, file_dxos_keys]);
/**
 * Describes the message dxos.halo.invitations.InvitationOptions.
 * Use `create(InvitationOptionsSchema)` to create a new message.
 */
export const InvitationOptionsSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 0);
/**
 * @generated from enum dxos.halo.invitations.InvitationOptions.Role
 */
export var InvitationOptions_Role;
(function (InvitationOptions_Role) {
    /**
     * Sentinel so neither real role is the proto3 default (which is stripped on the wire,
     * causing the receiver to see `role === undefined` and reject with InvalidInvitationExtensionRoleError).
     *
     * @generated from enum value: INVALID = 0;
     */
    InvitationOptions_Role[InvitationOptions_Role["INVALID"] = 0] = "INVALID";
    /**
     * @generated from enum value: GUEST = 1;
     */
    InvitationOptions_Role[InvitationOptions_Role["GUEST"] = 1] = "GUEST";
    /**
     * @generated from enum value: HOST = 2;
     */
    InvitationOptions_Role[InvitationOptions_Role["HOST"] = 2] = "HOST";
})(InvitationOptions_Role || (InvitationOptions_Role = {}));
/**
 * Describes the enum dxos.halo.invitations.InvitationOptions.Role.
 */
export const InvitationOptions_RoleSchema = /*@__PURE__*/ enumDesc(file_dxos_halo_invitations, 0, 0);
/**
 * Describes the message dxos.halo.invitations.IntroductionRequest.
 * Use `create(IntroductionRequestSchema)` to create a new message.
 */
export const IntroductionRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 1);
/**
 * Describes the message dxos.halo.invitations.IntroductionResponse.
 * Use `create(IntroductionResponseSchema)` to create a new message.
 */
export const IntroductionResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 2);
/**
 * Describes the message dxos.halo.invitations.AuthenticationRequest.
 * Use `create(AuthenticationRequestSchema)` to create a new message.
 */
export const AuthenticationRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 3);
/**
 * Describes the message dxos.halo.invitations.AuthenticationResponse.
 * Use `create(AuthenticationResponseSchema)` to create a new message.
 */
export const AuthenticationResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 4);
/**
 * @generated from enum dxos.halo.invitations.AuthenticationResponse.Status
 */
export var AuthenticationResponse_Status;
(function (AuthenticationResponse_Status) {
    /**
     * @generated from enum value: OK = 0;
     */
    AuthenticationResponse_Status[AuthenticationResponse_Status["OK"] = 0] = "OK";
    /**
     * @generated from enum value: INVALID_OTP = 1;
     */
    AuthenticationResponse_Status[AuthenticationResponse_Status["INVALID_OTP"] = 1] = "INVALID_OTP";
    /**
     * @generated from enum value: INVALID_OPT_ATTEMPTS = 2;
     */
    AuthenticationResponse_Status[AuthenticationResponse_Status["INVALID_OPT_ATTEMPTS"] = 2] = "INVALID_OPT_ATTEMPTS";
    /**
     * @generated from enum value: INTERNAL_ERROR = 3;
     */
    AuthenticationResponse_Status[AuthenticationResponse_Status["INTERNAL_ERROR"] = 3] = "INTERNAL_ERROR";
    /**
     * @generated from enum value: INVALID_SIGNATURE = 4;
     */
    AuthenticationResponse_Status[AuthenticationResponse_Status["INVALID_SIGNATURE"] = 4] = "INVALID_SIGNATURE";
})(AuthenticationResponse_Status || (AuthenticationResponse_Status = {}));
/**
 * Describes the enum dxos.halo.invitations.AuthenticationResponse.Status.
 */
export const AuthenticationResponse_StatusSchema = /*@__PURE__*/ enumDesc(file_dxos_halo_invitations, 4, 0);
/**
 * Describes the message dxos.halo.invitations.DeviceAdmissionRequest.
 * Use `create(DeviceAdmissionRequestSchema)` to create a new message.
 */
export const DeviceAdmissionRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 5);
/**
 * Describes the message dxos.halo.invitations.SpaceAdmissionRequest.
 * Use `create(SpaceAdmissionRequestSchema)` to create a new message.
 */
export const SpaceAdmissionRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 6);
/**
 * Describes the message dxos.halo.invitations.DelegateSpaceInvitation.
 * Use `create(DelegateSpaceInvitationSchema)` to create a new message.
 */
export const DelegateSpaceInvitationSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 7);
/**
 * Describes the message dxos.halo.invitations.CancelDelegatedInvitation.
 * Use `create(CancelDelegatedInvitationSchema)` to create a new message.
 */
export const CancelDelegatedInvitationSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 8);
/**
 * Describes the message dxos.halo.invitations.AdmissionRequest.
 * Use `create(AdmissionRequestSchema)` to create a new message.
 */
export const AdmissionRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 9);
/**
 * Describes the message dxos.halo.invitations.DeviceAdmissionCredentials.
 * Use `create(DeviceAdmissionCredentialsSchema)` to create a new message.
 */
export const DeviceAdmissionCredentialsSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 10);
/**
 * Describes the message dxos.halo.invitations.SpaceAdmissionCredentials.
 * Use `create(SpaceAdmissionCredentialsSchema)` to create a new message.
 */
export const SpaceAdmissionCredentialsSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 11);
/**
 * Describes the message dxos.halo.invitations.AdmissionResponse.
 * Use `create(AdmissionResponseSchema)` to create a new message.
 */
export const AdmissionResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_invitations, 12);
/**
 * / Host service for two peers exchanging an invitation.
 * TODO(wittjosiah): Handle invitations where guest is the initiatating peer.
 * TODO(dmaretskyi): Rename to InvitationExtensionService.
 *
 * @generated from service dxos.halo.invitations.InvitationHostService
 */
export const InvitationHostService = /*@__PURE__*/ serviceDesc(file_dxos_halo_invitations, 0);
//# sourceMappingURL=invitations_pb.js.map